"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
exports.request = async function request(ctx) {
    const requestConfig = ctx.request;
    try {
        const response = await ctx.instance.originalRequest(requestConfig); // 在这里面axios还会把requestConfig和axios的默认配置合并一次
        ctx.response = response;
    }
    catch (error) {
        ctx.response = error.response;
        ctx.error = error;
    }
    // 作为最后一个中间件，不再调next
};
exports.request.id = 'request';
var bigIntJson_1 = require("./bigIntJson");
Object.defineProperty(exports, "bigIntJson", { enumerable: true, get: function () { return bigIntJson_1.bigIntJson; } });
var cache_1 = require("./cache");
Object.defineProperty(exports, "cache", { enumerable: true, get: function () { return cache_1.cache; } });
var cancelWhenRouteChanged_1 = require("./cancelWhenRouteChanged");
Object.defineProperty(exports, "cancelWhenRouteChanged", { enumerable: true, get: function () { return cancelWhenRouteChanged_1.cancelWhenRouteChanged; } });
var cancelable_1 = require("./cancelable");
Object.defineProperty(exports, "cancelable", { enumerable: true, get: function () { return cancelable_1.cancelable; } });
var debounce_1 = require("./debounce");
Object.defineProperty(exports, "debounce", { enumerable: true, get: function () { return debounce_1.debounce; } });
var jwt_1 = require("./jwt");
Object.defineProperty(exports, "jwt", { enumerable: true, get: function () { return jwt_1.jwt; } });
var muteUnhandledRejectionError_1 = require("./muteUnhandledRejectionError");
Object.defineProperty(exports, "muteUnhandledRejectionError", { enumerable: true, get: function () { return muteUnhandledRejectionError_1.muteUnhandledRejectionError; } });
//# sourceMappingURL=index.js.map